import { normalizeURL } from "../../utils";

export const extractPath = (path: string) => {
  const stores = ["gb", "uk"];
  const params = path.split("/");
  return params
    .filter((segment: string) => !stores.includes(segment))
    .join("/");
};

export const arePathsEqual = (path1: string, path2: string): boolean => {
  const normalizedPath1 = normalizeURL(path1).toLowerCase();
  const normalizedPath2 = normalizeURL(path2).toLowerCase();
  return normalizedPath1 === normalizedPath2;
};
